import React, { useEffect, useRef, useState } from "react";
import { useDrag } from "react-dnd";
import moment from 'moment';
import "./TaskCard.scss";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import dashboardApi from "../../services/dashboardApi";
import { convertTimeToISO, findEndTime } from "../../utils/common";
import { ROStatusEnum } from "../../enum/enums";
const BASE_URL = process.env.REACT_APP_API_URL;
const MINUTES_TO_FINALMINUTES = process.env.REACT_APP_MINUTES_TO_FINALMINUTES;

const TaskCard = ({ children, unitWidth, slotsUntilNextTask, task, slot, stage, user, index, onClick, showStage, refetchData, fromUserList }) => {
  const partsAvailable = +task.partsReceivedPercentage.$numberDecimal;
  const dragRef = useRef(null);
  const [width, setWidth] = useState(unitWidth * task.duration); // Initial width in pixels
  const [initialWidth, setInitialWidth] = useState();
  const [status, setStatus]=useState()
  const step = unitWidth;
  
  const [{ isDragging }, drag, preview] = useDrag(() => ({
    type: "task",
    item: { task, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: (monitor) => {
      const element = dragRef.current;
      if (element) {
        const { left, right, top, bottom } = element.getBoundingClientRect();
        const clientX = monitor.getClientOffset().x;
        const clientY = monitor.getClientOffset().y;
        const restrictedArea = {
          top: 0,
          left: right - 50,
          right: right,
          bottom: bottom,
        };

        if (
          clientX >= restrictedArea.left &&
          clientX <= restrictedArea.right &&
          clientY >= restrictedArea.top &&
          clientY <= restrictedArea.bottom
        ) {
          return false; // Restrict dragging
        }
      }
      return fromUserList ? false : true; // Allow dragging
    },
  }));
  drag(preview(dragRef));

  const handleResizeStart = (event, { size }) => {
    setInitialWidth(size.width);
  };

  const handleResize = async (event, { size }) => {

    if (size.width !== initialWidth) 
      {
        setInitialWidth();
        const newWidth = size.width;
        const steps = newWidth / step; 
      
        let formattedData = {
          repairOrderId: task.repairOrderId,
          roNumber: task.roNumber,
          roStageId: task.roStageId,
          roStageName: task.roStageName,
          technicianId: task.technicianId,
          technicianName: task.technicianName,
          taskStartDate: task.taskStartDate,
          taskEndDate: task.taskEndDate,
          taskStartSlotId: task.taskStartSlotId,
          duration: steps,
          customerName: task.customerName,
        };
        const response = await dashboardApi.createorupdaterotaskschedule(
          formattedData
        );
        refetchData();
      }
    

  };

  
  const startTime = slot?.time;
const duration = task.duration;

useEffect(() => {  
  setStatus(task.taskStatus);  
  const start = moment(startTime, 'h A');
  const taskEndTime = start.clone().add(duration, 'hours');
  const now = moment();
  const timeUntilTaskEnds = taskEndTime.diff(now, 'seconds');
  const timeUntilFifteenMinutesBeforeEnd = taskEndTime.clone().subtract(MINUTES_TO_FINALMINUTES, 'minutes').diff(now, 'seconds'); // Minutes to final minutes
  let taskEndTimeout, fifteenMinutesTimeout;
  const onTaskEnd = async () => {
    console.log('Task has ended.', task.roNumber);
    if (task.taskStatus === 'inProgress' || task.taskStatus === 'notStarted' || task.taskStatus === 'finalMinutes') {
      setStatus('delayed');
      // call api 
      let formattedData = {
        roTaskScheduleId:task._id,
        taskStatus: ROStatusEnum.DELAYED, // Update status to delayed
      };
      console.log('API body for delayed task:', formattedData);
      try {
        const response = await dashboardApi.updateRepairOrderTaskScheduleItemStatus(formattedData);
        console.log('API response for delayed task:', response);
        refetchData(); // Refetch the updated data
      } catch (error) {
        console.error('Error updating task schedule:', error);
      }
       // call api
    }
  };

  const onFifteenMinutesBeforeEnd = async () => {
    if (task.taskStatus === 'inProgress') { // || task.taskStatus === 'notStarted'
      setStatus('finalMinutes');
       // call api   
       let formattedData = {
        roTaskScheduleId:task._id,
        taskStatus: ROStatusEnum.FINAL_MINUTES, // Update status to delayed
      };
      console.log('API body for finalMinutes task:', formattedData);
      try {
        const response = await dashboardApi.updateRepairOrderTaskScheduleItemStatus(formattedData);
        console.log('API response for delayed task:', response);
        refetchData(); // Refetch the updated data
      } catch (error) {
        console.error('Error updating task schedule:', error);
      }
       // call api      
    }
  };

  if (now.isAfter(taskEndTime)) {
    onTaskEnd();
  } else {
    if (timeUntilFifteenMinutesBeforeEnd <= 0 && timeUntilTaskEnds > 0) {
      onFifteenMinutesBeforeEnd();
    }

    if (timeUntilTaskEnds > 0) {
      taskEndTimeout = setTimeout(onTaskEnd, timeUntilTaskEnds * 1000);
    }

    if (timeUntilFifteenMinutesBeforeEnd > 0) {
      fifteenMinutesTimeout = setTimeout(onFifteenMinutesBeforeEnd, timeUntilFifteenMinutesBeforeEnd * 1000);
    }
  }

  return () => {
    if (taskEndTimeout) {
      clearTimeout(taskEndTimeout);
    }
    if (fifteenMinutesTimeout) {
      clearTimeout(fifteenMinutesTimeout);
    }
  };
}, [startTime, duration,task.taskStatus]);


  return (
    <div className="drag-wrapper" ref={dragRef}>
      <ResizableBox
        width={width}
        height={50}
        minConstraints={[step, 50]}
        maxConstraints={[(slotsUntilNextTask === 0 ? width : (width + step*slotsUntilNextTask)) , 50]}
        resizeHandles={fromUserList ? []:["e"]}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResize}
        draggableOpts={{ grid: [step, step] }}
        className={status + " columnTask"}
      >
        <div className="task-card" onClick={onClick}>
          <div className="task-name-wrap">
            <div className="task-name">{task.roNumber}</div>
            {showStage && (
              <div
              className="stage-img"
              style={{
                maskImage: `url(${BASE_URL + '/StageImages/'+task.roStageId+'.png'})`,
              }}
            ></div>
            )}
          </div>
          <div className="availability-wrap">
            <div className={`${partsAvailable > 0 ? "yes" : "no"} parts-availability`}></div>
          </div>
        </div>
      </ResizableBox>
    </div>
  );
};

export default TaskCard;
